import messageHelper from '../../../../components/Common/Message/MessageHelper';
import httpClient from '../../common/httpClient';

let allRegimes = new Map([
    ["Mifir", "MiFIR_RTS_22"],
    ["Emir", "EMIR_Old"],
    ["Asic", "ASIC_Old"],
    ["Iiroc", "OSC_Old"],
    ["Mas", "MAS_Old"],
    ["Sftr", "SFTR"],
    ["Refit", "EMIR"],
    ["AsicRewrite", "ASIC"],
    ["MasRewrite", "MAS"],
    ["OscRewrite", "OSC"],
    ["MifirCb", "MiFIR_CB"],
    ["MifirCp", "MiFIR_RTS_21"],
    ["SixDerivatives", "SIX_D"],
    ["SixSecurities", "SIX_S"],
    ["MifirTransparency", "MiFIR_RTS_1_2"],
    ["Cat", "CAT"],
    ["Remit", "REMIT"],
]);

const getRegimeDisplayName = (regime: string): string => {

    let regimesString = localStorage.getItem('regimes');

    if (!regimesString) {
        messageHelper.showMesage(`No value for regime ${regime}`);

        return '';
    }

    let regimes = new Map<string, string>(Object.entries(JSON.parse(regimesString)));

    return regimes.get(regime) as string;
}

const getRegime = (regimeDisplayName: string): string => {

    let regimesString = localStorage.getItem('regimes');

    if (!regimesString) {
        messageHelper.showMesage(`No value for regime ${regimeDisplayName}`);

        return '';
    }

    let regimes = JSON.parse(regimesString);

    for (const key in regimes) {

        if (regimes[key] === regimeDisplayName) {
            return key;
        }
    }
    return '';
}

const getRegimes = (): Map<string, string> => {

    let regimesString = localStorage.getItem('regimes') as string;

    if (!regimesString) {
        return proceedOnNoRegimes();

    }
    return new Map<string, string>(Object.entries(JSON.parse(regimesString)));
}

const getRegimesWithoutDeprecated = (): Map<string, string> => {

    let regimesString = localStorage.getItem('regimes') as string;

    if (!regimesString) {
        return proceedOnNoRegimes();
    }

    let regimes = new Map<string, string>(Object.entries(JSON.parse(regimesString)));

    const deprecatedRegimes = ['MiFIR Cb', 'ASIC', 'EMIR'];

    deprecatedRegimes.forEach((r) => {

        regimes.delete(r);
    });

    return regimes;
}

const proceedOnNoRegimes = () => {
    localStorage.setItem('regimes', JSON.stringify(allRegimes));

    return allRegimes;
}

const initialiseRegimes = async (): Promise<void> => {

    let res = await httpClient.get<Map<string, string>>('report/regimes');

    localStorage.setItem('regimes', JSON.stringify(res.data));
}

const hasRegimeSubregimes = (regime: string): boolean => {

    return regime === "EMIR REFIT";
}

const reportRegimeHelper = {
    getRegimeDisplayName,
    getRegime,
    hasRegimeSubregimes,
    getRegimes,
    getRegimesWithoutDeprecated,
    initialiseRegimes
};

export default reportRegimeHelper;
